/**
 * Utility functions to handle scroll disabling/enabling when popups are open
 */

let scrollPosition = 0;
let isScrollDisabled = false;

export const disableScroll = () => {
  if (isScrollDisabled) return;
  
  // Store current scroll position
  scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
  
  // Apply styles to prevent scrolling
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollPosition}px`;
  document.body.style.width = '100%';
  document.body.style.overflow = 'hidden';
  
  // Also prevent scrolling on html element for some edge cases
  document.documentElement.style.overflow = 'hidden';
  
  isScrollDisabled = true;
};

export const enableScroll = () => {
  if (!isScrollDisabled) return;
  
  // Restore normal scrolling
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';
  document.body.style.overflow = '';
  
  // Restore html element overflow
  document.documentElement.style.overflow = '';
  
  // Restore scroll position
  window.scrollTo(0, scrollPosition);
  
  isScrollDisabled = false;
};

export const isScrollCurrentlyDisabled = () => {
  return isScrollDisabled;
};

